import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DataConnectorHeader } from '../../-components/DataConnectorHeader';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/data-pipeline/_list')({
  component: InboundDataPipelineLayout
});
function InboundDataPipelineLayout() {
  return <div className="flex flex-col">
      <DataConnectorHeader section="inbound" />
      <Outlet />
    </div>;
}